import TitleText from "components/typography/titleText";
import React, { useState, useEffect, useRef } from "react";
import { CardSubtitle, Input } from "reactstrap"

function InputText({
  id="formId",
  placeholder="",
  name="formName",
  type="text",

  onChange=(e) => { console.log('onChange!') },
  onBlur= () => { console.log('onBlur!') },
  title = '',
  subtitle = '',
  required = false,
  value='',
  maxLength = 100,
  invalid=false,
  disabled=false,
  errorText = ''
}) {

  const handleOnChange = (e) => {
    onChange(e)
  }
  const handleOnBlur = (e) => {
    onBlur(e)
  }

  return (
    <>
      {title && (
        <div className="bSwitchGroup">
          {title && (
            <TitleText htmlFor={name}>
              {title}
              {required && <span className="t-require">*</span>}
            </TitleText>
          )}
          {subtitle && (
            <CardSubtitle className="mb-3">{subtitle}</CardSubtitle>
          )}
        </div>
      )}
      <div className="input-len-box">
        <Input
          id={id}
          className="form-control"
          type={type}
          rows="3"
          placeholder={placeholder}
          name={name}
          onChange={handleOnChange}
          onBlur={handleOnBlur}
          maxLength={maxLength}
          value={value}
          invalid={invalid}
          disabled={disabled}
        />
        {/* <p className="b-txt-count">{value.length}/{maxLength}</p> */}
        <p className="b-txt-count">{value.length}</p>
      </div>
      {
        invalid && (
          <div type="invalid"className="invalid-feedback d-block">
            {errorText}
          </div>
        )
      }
    </>
  )
}
export default InputText;
